import ApiProject from "../../../../../core/gd/api/project"
import asyncSessionLoader from "../../../../../core/gd/data/async-session-loader"

type APICallParams = {
    parentProject?  : ID
    name            : string
    color?          : number
}

const debug = false
// const debug = 'quickAdd_createGroup'

export default async function quickAdd_createGroup(params: APICallParams) {
    await asyncSessionLoader(gd.session.findMissing({
        // @ts-ignore
        projectsSettings: [params.parentProject, ...gd.session.projects.getAllParentsIds(params.parentProject)]
    }))

    // create project for Group
    const data = await ApiProject.newGroup({
        parentProjectId : params.parentProject,
        name            : params.name,
        color           : params.color,
    }).promise()

    return gd.session.projects.get(data.projectId)
}